import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Table,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Container,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import {
  extractIdFromUrl,
  showFullGroupName,
  showToast,
} from "../../helper-methods";
import {
  DeleteMemberAndGroup,
  groupDetails,
  NewGroupDetails,
} from "../../http/http-calls";
import { convertUrlToCdn } from "../../helper-methods";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import DeleteAlertModal from "../../components/modals/DeleteAlertModal";
import CopyLinkModal from "../../components/modals/CopyLinkModal";
import { Oval } from "react-loader-spinner";
import SubscriptionPlanModal from "../../components/modals/subscriptionPlanModal";

const GroupsViewPage = () => {
  const navigate = useNavigate();

  // state
  const [isEmbeddedLoading, setIsEmbeddedLoading] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [details, setDetails] = useState({});
  const [users, setUsers] = useState([]);
  const [delModeOpen, setDelModeOpen] = useState(false);
  const [deleteId, setDelId] = useState("");
  const [share, setShare] = useState(false);
  const [alias, setAlias] = useState("");

  const [isOpen, setIsOpen] = useState(false);
  const [subscription, setSubscription] = useState([]);
  const [flag, setFlag] = useState(false);

  const groupId = extractIdFromUrl();

  const _shareToggle = (share = false) => {
    setShare(share);
  };

  const _toggle = (isOpen = false, subscriptionPlan) => {
    setIsOpen(isOpen);
    setSubscription(subscriptionPlan);
  };

  // show all member details
  const _memberDetailsHandler = async () => {
    // Only show embedded loader for filtering, not initial load
    if (!isInitialLoad) setIsEmbeddedLoading(true);
    try {
      const res = await groupDetails(groupId);
      // console.log("memberDetailsPage>>",res)
      setDetails(res.data);
      setAlias(res.data.alias);
      _memberHandler();
      if (!isInitialLoad) setIsEmbeddedLoading(false);
      if (isInitialLoad) setIsInitialLoad(false);
    } catch (error) {
      // console.log(error)
      if (!isInitialLoad) setIsEmbeddedLoading(false);
      if (isInitialLoad) setIsInitialLoad(false);
    }
  };

  const _memberHandler = async () => {
    try {
      const res = await NewGroupDetails(groupId, {
        pageNumber: 1,
        pageSize: 10,
      });
      // console.log("Page>>",res)
      setUsers(res.members);
    } catch (error) {
      // console.log(error)
    }
  };
  /* eslint-disable */

  useEffect(() => {
    _memberDetailsHandler();
    setFlag(false);
  }, []);

  //see more button functionality
  const _seeMoreHandler = async () => {
    try {
      const res = await NewGroupDetails(groupId, {
        pageNumber: Math.ceil(users.length / 10) + 1,
        pageSize: 10,
      });
      // console.log("seeMore>>",res)
      setUsers(users.concat(res.members));
      // console.log("lllll",users.length);
      // console.log("0000", users.length+res.members.length);
    } catch (error) {
      // console.log(error)
    }
  };

  //delete member from group
  const _removeMember = async (memberId) => {
    // console.log(memberId);
    _deleteToggle(true, memberId);
  };
  const _deleteToggle = (delModeOpen = false, id) => {
    setDelModeOpen(delModeOpen);
    setDelId(id);
  };

  //delete api call
  const _deleteMemberHandler = async () => {
    try {
      const res = await DeleteMemberAndGroup(groupId, deleteId);
      // console.log("deleteCall",res);
      _memberDetailsHandler();
    } catch (error) {
      // console.log("errors",error);
      showToast(error.message, "error");
    }
  };

  const _shareLink = () => {
    _shareToggle(true);
  };

  const _showFullGroupName = () => {
    if (flag === false) {
      let newFlag = showFullGroupName(flag);
      setFlag(newFlag);
    } else {
      let newFlag = showFullGroupName(flag);
      setFlag(newFlag);
    }
  };

  const _showPlan = (member) => {
    return member.planName || "free";
  };

  const _showDate = (member) => {
    const newPlan = member?._joinGrouped?.find((data) => {
      if (data.isPaid === true) {
        if (data._group === details._id) {
          return true;
        }
      } else {
        return false;
      }
    });

    if (newPlan) {
      return moment(newPlan?.joinDate).format("DD MMM YYYY");
    } else {
      return moment(newPlan?.joinDate).format("DD MMM YYYY");
    }
  };
  return (
    <React.Fragment>
      {isEmbeddedLoading ? (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            margin: "40px 0",
            minHeight: "400px",
            alignItems: "center",
          }}
        >
          <Oval color="#3498DB" />
        </div>
      ) : (
        <>
          <Container>
            <div className="innerHeader">
              {/* page title */}
              <Link to="/groups" className="fs-16">
                <i className="fa fa-chevron-left me-1"></i> Back To Groups
              </Link>

              {/* <div className="right">
              <Input type="select">
                <option>All</option>
                <option>Active</option>
                <option>Inactive</option>
              </Input>
            </div> */}
            </div>

            <Row>
              <Col lg="4">
                <Card className="ProfileCard">
                  <CardHeader className="cover-image">
                    <img
                      src={
                        details?.displaypictureurl
                          ? convertUrlToCdn(details.displaypictureurl)
                          : require("../../assets/img/default-profile.svg")
                              .default
                      }
                      alt=""
                    />
                  </CardHeader>
                  <CardBody>
                    <div className="userProfile">
                      <img
                        src={
                          details.leader?.displaypictureurl
                            ? convertUrlToCdn(details.leader?.displaypictureurl)
                            : require("../../assets/img/default-profile.svg")
                                .default
                        }
                        alt=""
                      />
                      <div className="profile_info">
                        <h1
                          className="text-primary"
                          onClick={() => _showFullGroupName()}
                        >
                          {flag === false
                            ? details?.name?.length < 15
                              ? details?.name?.substring(0, 15)
                              : details?.name?.substring(0, 15) + "..."
                            : details?.name}
                        </h1>
                        <span className="fs-12">
                          {details?.leader?.fullname}
                        </span>
                      </div>
                    </div>

                    {/* List Group */}
                    <ListGroup className="profileListGroup mt-2 w-100">
                      <ListGroupItem>
                        <p>Created:</p>
                        <div>
                          {moment(details.createdAt).format("DD MMM YYYY")}
                        </div>
                      </ListGroupItem>
                      <ListGroupItem>
                        <p>Subscription:</p>
                        <Link
                          to=""
                          onClick={() =>
                            _toggle(true, details?.subscriptionPlan)
                          }
                        >
                          View Plan
                        </Link>
                        {/* {details.isPaid ? "$" : null}{details.isPaid? details?.subscriptionPlan?.map((data) => {return data.amount}) : " free"} */}
                      </ListGroupItem>
                      <ListGroupItem>
                        <p>Commission Charge:</p>
                        <div>
                          {details?.memberCommission
                            ? details?.memberCommission + "%"
                            : "N/A"}
                        </div>
                      </ListGroupItem>
                      <ListGroupItem>
                        <p>Invite Link:</p>
                        <i
                          className="fa fa-share-alt cursor-pointer me-2"
                          onClick={() => _shareLink()}
                        ></i>
                      </ListGroupItem>
                      <ListGroupItem>
                        <p>Total Earnings:</p>
                        <div>
                          ${details?.revenue?.totalRevenue.toFixed(2)}
                          <br />
                          <span style={{ fontWeight: 400 }}>
                            ($
                            {(
                              details?.revenue?.totalRevenue -
                              details?.revenue?.mediaRevenue
                            ).toFixed(2)}{" "}
                            Subscription & $
                            {details?.revenue?.mediaRevenue.toFixed(2)} Media)
                          </span>
                        </div>
                      </ListGroupItem>
                      <ListGroupItem>
                        <p>Shares:</p>
                        <div>
                          {/* $
                          {(
                            details?.revenue?.totalRevenue -
                            details?.revenue?.groupedRevenue
                          ).toFixed(2)}{" "}
                          User & ${details?.revenue?.groupedRevenue.toFixed(2)}{" "}
                          Grouped */}
                          $
                          {(
                            details?.revenue?.groupedRevenue +
                            details?.revenue?.mediaRevenueAfterDeduction
                          ).toFixed(2)}
                          User & $
                          {(
                            details?.revenue?.totalRevenue -
                            (details?.revenue?.groupedRevenue +
                              details?.revenue?.mediaRevenueAfterDeduction)
                          ).toFixed(2)}
                          Grouped
                        </div>
                      </ListGroupItem>
                    </ListGroup>
                  </CardBody>
                </Card>
              </Col>

              <Col lg="8" className="mt-4 mt-lg-0">
                <Card body className="ProfileCard">
                  <h4 className="fs-18 mb-3">
                    Members ({details.memberCount})
                  </h4>
                  <Table responsive>
                    <thead>
                      <tr>
                        <th>Member</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Joined</th>
                        <th>Subscription</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {users?.map((member, index) => (
                        <tr key={index}>
                          {/* <td className="text-capitalize">
                        <Link to="/groups-inner">{member.username}</Link>
                      </td> */}
                          <td
                            className="tableLink"
                            onClick={() =>
                              navigate(`/members-view/${member._id}`)
                            }
                          >
                            {member.fullname}
                          </td>
                          <td>{member.email}</td>
                          <td>{member.phone}</td>
                          <td>
                            {details?.leader?._id !== member._id
                              ? _showDate(member)
                              : "N/A"}
                          </td>

                          <td>
                            {details?.leader?._id !== member._id
                              ? _showPlan(member)
                              : "N/A"}
                          </td>
                          <td>
                            {details?.leader?._id !== member._id ? (
                              <div className="action">
                                <Button color="link" className="delete">
                                  <i
                                    className="fas fa-trash-alt"
                                    onClick={() => _removeMember(member._id)}
                                  ></i>
                                </Button>
                              </div>
                            ) : null}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>

                  <Button color="link" onClick={() => _seeMoreHandler()}>
                    {details.memberCount !== users.length ? "See More" : null}
                  </Button>
                </Card>
              </Col>
            </Row>

            <SubscriptionPlanModal
              isOpen={isOpen}
              toggle={() => _toggle()}
              subscription={subscription}
            />

            <CopyLinkModal
              share={share}
              toggle={() => _shareToggle()}
              alias={alias}
            />

            {/* pagination */}
            {/* <PaginatedItems itemsPerPage={4} /> */}
            <DeleteAlertModal
              delModeOpen={delModeOpen}
              deleteMemberView={() => _deleteMemberHandler()}
              toggle={() => _deleteToggle()}
            />
          </Container>
        </>
      )}
    </React.Fragment>
  );
};

export default GroupsViewPage;
